export const mdl12Urls = {
  uploadFileURL: '/mdl12/UploadFile',
}
